<template>
  <div class="mobile-menu">
    <i @click="closeMenu" class="el-icon-close"></i>
    <ul>
      <router-link exact-active-class="app-button" tag="li" to="/">
        BUY TICKET <i class="fas fa-ticket-alt"></i>
      </router-link>
      <router-link class="link" exact-active-class="app-button" tag="li" to="checkin">
        MANAGE BOOKING <i class="fas fa-walking"></i>
      </router-link>
      <router-link v-show="isAuth" class="link"  exact-active-class="app-button" tag="li" to="profile">
        PROFILE
        <i class="fas fa-user-circle"></i>
      </router-link>
      <router-link @click.native="onLogout"  v-if="isAuth" class="link"  exact-active-class="app-button" tag="li" to="auth">
        LOGOUT
        <i class="fas fa-user-circle"></i>
      </router-link>
      <router-link v-else class="link"  exact-active-class="app-button" tag="li" to="auth">
        LOGIN
        <i class="fas fa-user-circle"></i>
      </router-link>
    </ul>
  </div>
</template>

<script>

const configMenus = [
  {
    title: 'Passenger',
    url: '/passenger'
  },
  {
    title: 'Trips',
    url: '/admin/trips'
  },
  {
    title: 'Location',
    url: 'admin/locations'
  }
]
export default {
  name: 'mobile-menu',
  props: ['closeMenu'],
  data () {
    return {
      menus: configMenus,
      isAuth: false
    }
  }
}
</script>

<style lang="scss" src="../sass/mobile-menu.scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/MobileMenu.vue